export default {
  'loyaltyMember.title': '会员',
  'loyaltyMember.add.title': '添加新会员',
  'loyaltyMember.edit.title': '编辑会员',
  'loyaltyMember.required.desc': '*为必填项',

  'loyaltyMember.column.name': '名字',
  'loyaltyMember.column.phone_number': '电话',
  'loyaltyMember.column.member_card_number': '卡号',
  'loyaltyMember.column.email': '邮箱',
  'loyaltyMember.column.birthday': '生日',
  'loyaltyMember.column.status': '状态',
  'loyaltyMember.column.expiration_date': '过期日期',
  'loyaltyMember.column.usable_amount': '返现余额',
  'loyaltyMember.column.cash_back_balance': '返现余额',
  'loyaltyMember.column.usable_points': '积分',
  'loyaltyMember.column.points': '积分',
  'loyaltyMember.column.prepaid_card_balance': '充值卡余额',
  'loyaltyMember.column.balance': '可用余额',
  'loyaltyMember.column.total_visits': '总到访',
  'loyaltyMember.column.total_revenue': '总消费',
  'loyaltyMember.column.last_visit_at': '上次到访',
  'loyaltyMember.column.created_at': '入会日期',
  'loyaltyMember.column.level': '等级',
  'loyaltyMember.column.lifetime_cash_back': '历史总返现',
  'loyaltyMember.column.source': '注册来源',
  'loyaltyMember.column.registerFrom': '注册来源',
  'loyaltyMember.unit.balance': '积点',
  'loyaltyMember.alias.status': '会员状态',

  'loyaltyMember.name.placeholder': '全名',
  'loyaltyMember.query.placeholder': '通过名字或者电话号或者卡号码搜索',
  'loyaltyMember.source.placeholder': '选择注册来源',
  'loyaltyMember.query.expiredDateRange': '过期时间段过滤',

  'loyaltyMember.section.basic_info': '基本信息',
  'loyaltyMember.section.membership': '会员信息',
  'loyaltyMember.section.note': '备注',
  'loyaltyMember.section.transactions': '交易记录',

  'loyaltyMember.action.addNote': '添加备注',
  'loyaltyMember.action.editNote': '编辑备注',

  'loyaltyMember.name.required': '姓名必填',
  'loyaltyMember.phone_number.required': '手机号必填',
  'loyaltyMember.source.required': '注册来源必填',

  'loyaltyMember.created_at.desc': '入会日期 {created_at}',
  'loyaltyMember.updateSuccess': '更新会员成功',
  'loyaltyMember.createSuccess': '新增会员成功',

  'loyaltyMemberTransaction.column.created_at': '时间',
  'loyaltyMemberTransaction.column.transaction_type': '交易类型',
  'loyaltyMemberTransaction.column.staff': '员工',
  'loyaltyMemberTransaction.column.balance': '余额',
  'loyaltyMemberTransaction.column.total': '会员账户余额支付金额',
  'loyaltyMemberTransaction.column.order_number': '订单号',
  'loyaltyMemberTransaction.column.cash_back_issued': '获取返现',
};
